import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTopSites } from '../../../../shared/chromeApi';
import { GlobalState } from '../../../types.global';
import { AdTileInt } from './types';

const getAdTiles = async (): Promise<AdTileInt[]> => {
  let config;

  try {
    config = (await chrome.storage.local.get('partnersConfig')).partnersConfig;
  } catch (err) {
    // Get the config from the server
    config = await fetch(process.env.APP_URL + '/api/partners')
      .then((res) => res.json())
      .catch((err) => {
        console.error('partnersConfig', err);
        return null;
      });
  }

  if (!config) return [];

  let country = 'US';

  try {
    const { countryCode = 'US' } = await chrome.storage.local.get(
      'countryCode'
    );
    country = countryCode;
  } catch (err) {
    // Get the country code from ipapi
    // First fetch from the local storage
    // If not found, fetch from the ipapi
    const countryCode = localStorage.getItem('countryCode');

    if (countryCode) {
      country = countryCode;
    } else {
      const { country_code } = await fetch('https://ipapi.co/json/')
        .then((res) => res.json())
        .catch(() => ({}));

      if (!country_code) {
        return;
      }

      localStorage.setItem('countryCode', country_code);

      country = country_code;
    }
  }

  return fetch(
    process.env.APP_URL + '/api/tiles/combined?country=' + country
  )
    .then((res) => res.json())
    .then((list) => {
      return list;
    })
    .catch((err) => {
      console.error('tilesPromise', err);
      return { tiles: [] };
    });
};

type TopSitesResult = {
  value: chrome.topSites.MostVisitedURL[];
  savedAt: number;
};
type AdTilesResult = { value: AdTileInt[]; savedAt: number };

export const fetchTiles = createAsyncThunk(
  'tiles/fetchTiles',
  async (_, thunkAPI) => {
    const state = thunkAPI.getState() as GlobalState;
    const [topSites, adTiles] = await Promise.all([
      (async (): Promise<TopSitesResult> => {
        const value = await getTopSites().catch(() => []);
        return { value, savedAt: Date.now() };
      })(),
      (async (): Promise<AdTilesResult> => {
        const result = await getAdTiles();

        return { value: result.flat(), savedAt: Date.now() };
      })(),
    ]);

    // console.log('topSites', topSites, adTiles);

    return { topSites, adTiles };
  }
);
